import React, { useEffect, useState, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  Input,
  Form,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  UncontrolledTooltip
} from "reactstrap";
import classnames from "classnames";
import * as Yup from "yup";
import { useFormik } from "formik";
import { NameSurname, Status } from "./contactlistCol";
import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";
import axios from 'axios';
import Dropzone from 'react-dropzone-uploader';
import { useSelector, useDispatch } from "react-redux";
import {
  getProduct as onGetProduct,
  addProduct as onAddProduct,
  updateProduct as onUpdateProduct,
  deleteProduct as onDeleteProduct,
} from "store/contacts/actions";
import { Price } from "../Orders/contactlistCol";

const ContactsList = props => {
  document.title = "Ürünler | Tazelya ADMIN PANELI";

  const dispatch = useDispatch();
  const { users } = useSelector(state => ({
    users: state.contacts.products,
  }));

  const [modal, setModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [contactEdit, setEditContact] = useState(null);
  const [activeTab, setActiveTab] = useState("1");
  
    const UPLOAD_URL = 'https://bittigitti.online:9024/uploadfile';

  // Medya ve Durum State'leri
  const [getFileName, setFileName] = useState(null);
  const [getIsActive, setIsActive] = useState(false);
  const [getCategoryID, setCategoryID] = useState("");
  const [categories, setCategories] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [getFileMobileCheck, setFileMobileCheck] = useState(false);

  const unitOptions = [
  { label: "Adet", en: "Piece", ar: "قطعة" },
  { label: "Kg", en: "Kg", ar: "كجم" },
  { label: "Gram", en: "Gram", ar: "gram" },
  { label: "Demet", en: "Bunch", ar: "حزمة" },
  { label: "Paket", en: "Package", ar: "رزمة" },
  { label: "Litre", en: "Liter", ar: "لتر" },
];

  // --- API VERİ ÇEKME ---
  useEffect(() => {
    dispatch(onGetProduct());
    // Kategorileri yükle
    axios.get(`https://tazelyadmin.stechomeyazilim.info:5556/getProduct_CategoryBitti/select/`)
      .then(res => setCategories(res.data))
      .catch(err => console.log("Kategori çekme hatası:", err));
  }, [dispatch]);

  // --- FORMIK YAPILANDIRMASI ---
  const validation = useFormik({
    enableReinitialize: true, // BU ÇOK ÖNEMLİ: Edit verisi gelince formun güncellenmesini sağlar.
    initialValues: {
      // Buradaki key isimleri Input'lardaki 'name' özelliği ile birebir aynı olmalı
      title: (contactEdit && contactEdit.Products_Name) || "",
      title_en: (contactEdit && contactEdit.Products_Name_En) || "",
      title_ar: (contactEdit && contactEdit.Products_Name_Ar) || "",
      desc: (contactEdit && contactEdit.ProductsDesc) || "",
      desc_en: (contactEdit && contactEdit.ProductsDesc_En) || "",
      desc_ar: (contactEdit && contactEdit.ProductsDesc_Ar) || "",
      price: (contactEdit && contactEdit.Price) || "",
      disprice: (contactEdit && contactEdit.DiscountedPrice) || "",
      stock: (contactEdit && contactEdit.Stock) || "",

      unitType: (contactEdit && contactEdit.UnitType) || "Adet", // Varsayılan Adet
    unitType_en: (contactEdit && contactEdit.UnitType_En) || "Piece",
    unitType_ar: (contactEdit && contactEdit.UnitType_Ar) || "قطعة",
    unitValue: (contactEdit && contactEdit.UnitValue) || 1, // Örn: 1 Kg veya 500 Gram

    // YENİ EKLENENLER: Artış Miktarı ve Minimum Miktar
      stepValue: (contactEdit && contactEdit.StepValue) || 1,
      minQuantity: (contactEdit && contactEdit.MinQuantity) || 1,
    },
    validationSchema: Yup.object({
      title: Yup.string().required("Ürün adı zorunludur"),
      price: Yup.number().required("Fiyat zorunludur"),
      stock: Yup.number().required("Stok zorunludur"),
    }),
   onSubmit: (values) => {

    const selectedUnit = unitOptions.find(u => u.label === values.unitType) || unitOptions[0];

  const payload = {
    // Sayısal değerleri garantiye alıyoruz (float ve int için)
    ID: isEdit ? contactEdit.ID : undefined, 
    Products_Name: values.title,
    Products_Name_En: values.title_en,
    Products_Name_Ar: values.title_ar,
    ProductsDesc: values.desc,
    ProductsDesc_En: values.desc_en,
    ProductsDesc_Ar: values.desc_ar,
    Price: parseFloat(values.price) || 0,
    DiscountedPrice: parseFloat(values.disprice) || 0,
    Stock: parseInt(values.stock) || 0,
    Product_Category_ID: parseInt(getCategoryID),
    IsActive: getIsActive ? true : false, // SQL Bit alanı için 1/0 daha güvenlidir
    ImageCover: getFileName,
    MobileCheck: getFileMobileCheck ? true : false,
    UnitType: values.unitType,
     
    UnitType: values.unitType,
    UnitType_En: selectedUnit.en, // Otomatik eşleşme
    UnitType_Ar: selectedUnit.ar, // Otomatik eşleşme
    UnitValue: parseFloat(values.unitValue) || 1,

    // YENİ EKLENENLER: Veritabanına gidecek isimleriyle eşleştiriyoruz
        StepValue: parseFloat(values.stepValue) || 1,
        MinQuantity: parseFloat(values.minQuantity) || 1,
  };

  console.log("lkmsşkldf", payload)
  if (isEdit) {
    // Bazı API yapıları ID'yi payload içinde değil, ayrı bir parametre olarak bekler.
    // Redux aksiyonunuzun yapısına göre kontrol edin:
    dispatch(onUpdateProduct(payload)); 
  } else {
    dispatch(onAddProduct(payload));
  }
  toggle();
},
  });

  // --- DÜZENLEME TETİKLEYİCİ ---
  const handleEditClick = (user) => {
    setEditContact(user); // Formik initialValues buradan besleniyor
    setCategoryID(user.Product_Category_ID || "");
    setIsActive(user.IsActive || false);
    setFileName(user.ImageCover || null);
    setFileMobileCheck(user.MobileCheck || false);
    setIsEdit(true);
    setModal(true);
  };

  const toggle = () => {
    setModal(!modal);
    if (!modal) {
      setEditContact(null);
      setFileName(null);
      setIsEdit(false);
      setActiveTab("1");
    }
  };

  // --- TABLO KOLONLARI ---
  const columns = useMemo(() => [
    {
      Header: "Foto",
      accessor: (row) => (
        <div className="avatar-xs">
          {row.ImageCover ? (
            <img 
              className="rounded-circle avatar-xs" 
              src={'https://bittigittipreview.stechomeyazilim.info/' + row.ImageCover} 
              alt="" 
            />
          ) : (
            <span className="avatar-title rounded-circle">{row.Products_Name?.charAt(0)}</span>
          )}
        </div>
      ),
    },
    { Header: "Ürün Adı", accessor: "Products_Name", Cell: cellProps => <NameSurname {...cellProps} /> },
    { Header: "Stok", accessor: "Stock" },

{ 
  Header: "Fiyat / Birim", 
  accessor: "Price", 
  Cell: cellProps => (
    <span>
      {cellProps.row.original.Price} TL / {cellProps.row.original.UnitValue} {cellProps.row.original.UnitType}
    </span>
  ) 
},

{ Header: "Durum", accessor: "IsActive", Cell: cellProps => <Status {...cellProps} /> },
    {
      Header: "İşlemler",
      Cell: cellProps => (
        <div className="d-flex gap-3">
          <Link to="#" className="text-success" onClick={() => handleEditClick(cellProps.row.original)}>
            <i className="mdi mdi-pencil font-size-18" />
          </Link>
          <Link to="#" className="text-danger" onClick={() => { setEditContact(cellProps.row.original); setDeleteModal(true); }}>
            <i className="mdi mdi-delete font-size-18" />
          </Link>
        </div>
      ),
    },
  ], []);

  // Media Upload İşlemleri
  const handleChangeStatus = ({ xhr }) => {
    if (xhr && xhr.readyState === 4) {
      const result = JSON.parse(xhr.response);
      setFileName(result.file.filename);
      setFileMobileCheck(false);
    }
  };


    const getUploadParams = ({ file }) => {
    const body = new FormData();
    body.append('dataFile', file);
    return { url: UPLOAD_URL, body };
  };

  const handleChangeImageStatus = ({ xhr }) => {
    if (xhr && xhr.readyState === 4) {
      const result = JSON.parse(xhr.response);
      setFileName(result.file.filename);
    }
  };



  const Preview = ({ meta }) => {
    const { name, percent, status, previewUrl } = meta;
    return (
      <div className="preview-box p-2 border mb-2">
        <img src={previewUrl} style={{ height: '50px' }} alt="preview" /> 
        <span className="ms-2">{name} - {status === "done" ? "Hazır" : `%${Math.round(percent)}`}</span>
      </div>
    );
  };

  return (
    <React.Fragment>
   <DeleteModal 
  show={deleteModal} 
  onDeleteClick={() => { 
    // editContact değil, contactEdit olmalı
    if (contactEdit && contactEdit.ID) {
      dispatch(onDeleteProduct(contactEdit.ID)); 
    }
    setDeleteModal(false); 
  }} 
  onCloseClick={() => setDeleteModal(false)} 
/>
      
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="E-Ticaret" breadcrumbItem="Ürün Yönetimi" />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={users || []}
                    isGlobalFilter={true}
                    isAddProduct={true}
                    handleOrderClicks={() => { setIsEdit(false); setEditContact(null); setModal(true); }}
                    customPageSize={10}
                  />

                  <Modal size="lg" isOpen={modal} toggle={toggle} centered>
                    <ModalHeader toggle={toggle}>{isEdit ? "Ürünü Düzenle" : "Yeni Ürün Ekle"}</ModalHeader>
                    <ModalBody>
                      <Form onSubmit={(e) => { e.preventDefault(); validation.handleSubmit(); }}>
                        
                        <Nav tabs className="nav-tabs-custom nav-justified">
                          <NavItem><NavLink className={classnames({ active: activeTab === "1" })} onClick={() => setActiveTab("1")}>Türkçe</NavLink></NavItem>
                          <NavItem><NavLink className={classnames({ active: activeTab === "2" })} onClick={() => setActiveTab("2")}>English</NavLink></NavItem>
                          <NavItem><NavLink className={classnames({ active: activeTab === "3" })} onClick={() => setActiveTab("3")}>العربية</NavLink></NavItem>
                        </Nav>

                        <TabContent activeTab={activeTab} className="p-3">
                          <TabPane tabId="1">
                            <div className="mb-3">
                              <Label>Ürün Adı (TR)</Label>
                              <Input name="title" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.title} invalid={validation.touched.title && !!validation.errors.title} />
                              <FormFeedback>{validation.errors.title}</FormFeedback>
                            </div>
                            <div className="mb-3">
                              <Label>Açıklama (TR)</Label>
                              <Input name="desc" type="textarea" rows="3" onChange={validation.handleChange} value={validation.values.desc} />
                            </div>


                         <div className="mb-3">
    <Label>Ürün Birimi</Label>
    <select 
      name="unitType" 
      className="form-select"
      onChange={validation.handleChange} 
      value={validation.values.unitType}
    >
      {unitOptions.map((option, idx) => (
        <option key={idx} value={option.label}>
          {option.label}
        </option>
      ))}
    </select>
  </div>
</TabPane>

                          <TabPane tabId="2">
                            <div className="mb-3">
                              <Label>Product Name (EN)</Label>
                              <Input name="title_en" type="text" onChange={validation.handleChange} value={validation.values.title_en} />
                            </div>
                            <div className="mb-3">
                              <Label>Description (EN)</Label>
                              <Input name="desc_en" type="textarea" rows="3" onChange={validation.handleChange} value={validation.values.desc_en} />
                            </div>
                          </TabPane>

                          <TabPane tabId="3">
                            <div className="mb-3 text-end">
                              <Label>اسم المنتج (AR)</Label>
                              <Input dir="rtl" name="title_ar" type="text" onChange={validation.handleChange} value={validation.values.title_ar} />
                            </div>
                            <div className="mb-3 text-end">
                              <Label>وصف المنتج (AR)</Label>
                              <Input dir="rtl" name="desc_ar" type="textarea" rows="3" onChange={validation.handleChange} value={validation.values.desc_ar} />
                            </div>
                          </TabPane>
                        </TabContent>

                        <Row className="px-3">
                          <Col md={4}><div className="mb-3"><Label>Fiyat</Label><Input name="price" type="number" onChange={validation.handleChange} value={validation.values.price} /></div></Col>
                          <Col md={4}><div className="mb-3"><Label>İndirimli Fiyat</Label><Input name="disprice" type="number" onChange={validation.handleChange} value={validation.values.disprice} /></div></Col>
                          <Col md={4}><div className="mb-3"><Label>Stok</Label><Input name="stock" type="number" onChange={validation.handleChange} value={validation.values.stock} /></div></Col>
                          
                          <Col md={4}>
    <div className="mb-3">
      <Label>Birim Miktarı (Örn: 1 veya 500)</Label>
      <Input 
        name="unitValue" 
        type="number" 
        step="0.01" // 0.5 kg gibi değerler için önemli
        onChange={validation.handleChange} 
        value={validation.values.unitValue} 
      />
    </div>
  </Col>


<Col md={4}>
    <div className="mb-3">
      <Label>Sepete Ekleme Adımı (Örn: 0.5)</Label>
      <Input 
        name="stepValue" 
        type="number" 
        step="0.01" 
        onChange={validation.handleChange} 
        value={validation.values.stepValue} 
      />
    </div>
  </Col>

  {/* YENİ EKLENEN: Minimum Sipariş Miktarı */}
  <Col md={4}>
    <div className="mb-3">
      <Label>Minimum Sipariş (Örn: 1)</Label>
      <Input 
        name="minQuantity" 
        type="number" 
        step="0.01" 
        onChange={validation.handleChange} 
        value={validation.values.minQuantity} 
      />
    </div>
  </Col>
  
                          <Col md={6}>
                            <div className="mb-3">
                              <Label>Kategori</Label>
                              <select className="form-select" value={getCategoryID} onChange={(e) => setCategoryID(e.target.value)}>
                                <option value="">Seçiniz...</option>
                                {categories.map(cat => <option key={cat.ID} value={cat.ID}>{cat.Product_Category_Title}</option>)}
                              </select>
                            </div>
                          </Col>

                      <Col md={6}>
  <Label htmlFor="activeSwitch">Durum</Label>
<div 
  className="form-check form-switch form-switch-md mb-3" 
  onClick={() => setIsActive(!getIsActive)} // Tıklamayı kapsayıcı div'e verin
  style={{ cursor: 'pointer' }}
>
  <input
    type="checkbox"
    className="form-check-input"
    checked={!!getIsActive}
    readOnly // Değişim dışarıdaki div'den yönetildiği için
  />
  <label className="form-check-label" style={{ cursor: 'pointer' }}>
    {getIsActive ? "Aktif" : "Pasif"}
  </label>
</div>
</Col>

                          <Col md={12}>
                            <Label>Görsel</Label>
                              <Dropzone
                                getUploadParams={getUploadParams}
                                onChangeStatus={handleChangeImageStatus}
                                maxFiles={1}
                                multiple={false}
                                canRemove={true}
                                accept="image/*"
                                PreviewComponent={Preview}
                                inputContent="Görseli buraya sürükleyin"
                                styles={{ dropzone: { minHeight: 120, border: '2px dashed #ced4da' } }}
                              />
                              {getFileName && <p className="text-success mt-1">Yüklü: {getFileName}</p>}

                            {getFileName && (
                              <div className="mt-2 text-center">
                                <img src={(getFileMobileCheck ? 'https://kampanya.stechomeyazilim.com/Uploads/' : 'https://bittigittipreview.stechomeyazilim.info/') + getFileName} style={{height: "100px"}} className="img-thumbnail" alt="" />
                              </div>
                            )}
                          </Col>
                        </Row>

                        <div className="text-end mt-4 px-3">
                          <button type="submit" className="btn btn-success w-md">{isEdit ? "Güncelle" : "Kaydet"}</button>
                        </div>
                      </Form>
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ContactsList);